// Organization To contact Reducer

const organizationToContactDefaultState = {
    list : []
};

export default (state = organizationToContactDefaultState, action) => {
    switch (action.type) {
        case 'SET_ORGANIZATION_TO_CONTACT':
            return {
                ...state,
                list : action.data
            };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/organizationToContact.js